import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { AppointmentsResponseModel } from '../model';

@Injectable({
  providedIn: 'root',
})
export class AppointmentsService {
  constructor(private http: HttpClient) {}

  public getAppointmentsSchedule(): Observable<AppointmentsResponseModel[]> {
    return this.http.get<AppointmentsResponseModel[]>(`${environment.apiEndpoint}/b2b/livecalls`);
  }
}
